module.exports = __webpack_public_path__ + "img/IMG_9000_FoamcoreMatted.32e73502.jpg";